import { useActive, useCommands } from '@remirror/react';
import React, { FC, useCallback } from 'react';

import { WFormatBoldExtension } from '../../index';
import { CommandButton, ICommandButtonProps } from '../../../components/buttons/CommandButton';

export type IToggleWFormatBoldButtonProps = Omit<
  ICommandButtonProps,
  'commandName' | 'active' | 'enabled' | 'attrs' | 'onSelect'
>;

export const ToggleWFormatBoldButton: FC<IToggleWFormatBoldButtonProps> = (props) => {
  const type = 'bold';
  const { toggleWFormatBold: command, focus } = useCommands<WFormatBoldExtension>();
  const active = useActive<WFormatBoldExtension>().wFormatBold({
    type,
  });
  const enabled = command.enabled({ type });

  const handleClick = useCallback(() => {
    if (enabled) {
      command({ type });
      focus();
    }
  }, [command]);

  return (
    <CommandButton
      {...props}
      commandName="toggleWFormatBold"
      active={active}
      enabled={enabled}
      onSelect={handleClick}
    />
  );
};
